import e from "../_virtual/_plugin-vue_export-helper.js";
import t from "./SchemaPropertyDefault.vue.script.js";
/* empty css                                    */
//#region src/schema/SchemaPropertyDefault.vue
var n = /*#__PURE__*/ e(t, [["__scopeId", "data-v-46973243"]]);
//#endregion
export { n as default };

//# sourceMappingURL=SchemaPropertyDefault.vue.js.map